
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 242.5 239.5","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M138.2 105.2h-33.9l17.6 29.1 16.3-29.1z","fill":"#fdbd3a"}}),_c('path',{attrs:{"d":"M223.2 172.5l-22.9-38.1L128 15 1.8 224.5h67.6c9 0 17.9-2.3 25.8-6.6 7.8-4.3 14.4-10.5 19-17.9l34.6-57.8-19.2-31.8L87.9 180c-2.4 3.9-5.7 7.1-9.8 9.3-4.1 2.2-8.6 3.4-13.3 3.4h-5.1l68.6-113.8 87.8 145.6H241v-23.2l-17.8-28.8z"}})])
          )
        }
      }
    